export const BidStatuses = {
    Verified: {
        title: 'Verified',
        className: 'badge-soft-success',
        color: 'success',
        icon: 'ri-checkbox-circle-fill',
    },
    Rejected: {
        title: 'Rejected',
        className: 'badge-soft-danger',
        color: 'danger',
        icon: 'ri-close-circle-fill',
    },
    'Action Required': {
        title: 'Action Required',
        className: 'badge-soft-warning',
        color: 'warning',
        icon: 'ri-alert-line',
    },
    Verifying: {
        title: 'Verifying',
        className: 'badge-soft-info',
        color: 'primary',
        icon: 'ri-time-line',
    },
};

export const BidVerificationStages = [
    'Documents',
    'Company',
    'Digital ID',
    'Call Verification',
    'Gate Security',
];

export const BidVerificationProgressStates = {
    completed: {
        title: 'Completed',
        icon: 'ri-checkbox-circle-fill',
        className: 'text-success',
    },
    in_progress: {
        title: 'In progress',
        icon: 'ri-checkbox-blank-fill',
        className: 'text-primary',
    },
    issues: {
        title: 'Issues found',
        icon: 'ri-error-warning-fill',
        className: 'text-danger',
        replaceTitle: true,
    },
    not_completed: {
        title: 'Not completed',
        icon: 'ri-indeterminate-circle-line',
        className: 'text-muted',
    },
};